import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerText from '../../../components/custom_components/Text'
import PerSpacer from '../../../components/custom_components/Spacer'
import { PerCardInfo } from '../../../components/custom_components/CardInfo'
import { FullMeetingFragment } from '../../../types'
import { AppraisalContextType } from '../AppraisalTypes'
import { useAuth } from '../../../context/auth-context'
import { isUserHrForCountry } from '../../../shared/rolesUtil'

type Props = {
  type: AppraisalContextType
  meeting: FullMeetingFragment
  employeeStartedPreparing: boolean
}

export const EvaluationDescriptionComponent: FC<Props> = ({ type, meeting }) => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const isHrForCountry = isUserHrForCountry(meeting.appraisalSeason.country, user.roles)

  const meetingPrepared = meeting.employeePrepared
  const meetingShared = meeting.appraisal ? meeting.appraisal.evaluationShared : false
  const notPrepared = !meetingPrepared
  const notShared = !notPrepared && !(meetingShared || isHrForCountry)

  const notSharedInManagerPrep = notShared && type === AppraisalContextType.Manager
  const notPreparedInManagerPrep = notPrepared && type === AppraisalContextType.Manager
  const notPreparedInMeeting = notPrepared && type === AppraisalContextType.Meeting

  const employeeFirstName = meeting.employee.chosenFirstName ? meeting.employee.chosenFirstName : meeting.employee.legalFirstName

  const renderInfoCardHeading = () => {
    const text = (type) =>
      t(`appraisalMeeting.evaluation.managerPreparation.infoCard.heading.${type}`, {
        employeeName: employeeFirstName,
      })

    if (notPreparedInManagerPrep) {
      return text('notPrepared')
    } else if (notPreparedInMeeting) {
      return text('notPreparedMeeting')
    } else if (notSharedInManagerPrep) {
      return text('notShared')
    } else {
      return ''
    }
  }

  const renderInfoCardDescription = () => {
    const text = (type) =>
      t(`appraisalMeeting.evaluation.managerPreparation.infoCard.subheading.${type}`, {
        employeeName: employeeFirstName,
      })

    if (notPreparedInManagerPrep) {
      return text('notPrepared')
    } else {
      return undefined
    }
  }

  return (
    <>
      {(notPreparedInManagerPrep || notPreparedInMeeting || notSharedInManagerPrep) && (
        <PerSpacer mb="xl">
          <PerCardInfo
            heading={renderInfoCardHeading()}
            description={renderInfoCardDescription()}
            icon={{ name: notPreparedInMeeting ? 'info_stroke' : undefined }}
          />
        </PerSpacer>
      )}

      <PerText mb="l" color="secondary">
        {t(`appraisalMeeting.evaluation.${type}PageDescription`)}
      </PerText>
      <PerText mb="l" color="secondary">
        {t(`appraisalMeeting.evaluation.${type}PageDescription1`)}
      </PerText>
      <PerText mb="l" color="secondary">
        {t(`appraisalMeeting.evaluation.${type}PageDescription2`)}
      </PerText>
      {type === AppraisalContextType.Manager && (
        <PerText mb="l" color="secondary">
          {t(`appraisalMeeting.evaluation.${type}PageDescription3`)}
        </PerText>
      )}
    </>
  )
}
